import { MAX_CONTRACTS_AGREEMENTS } from "@/common/constants"
import subscribedAgreementsServices from "@/modules/govern/non-cx/subscribedAgreements/services/subscribedAgreements"
import { defineStore } from "pinia"
import { Ref, ref } from "vue"

const useHomeStore = defineStore("homeStore", () => {
  // State
  const providerContracts = ref<any[]>([])
  const consumerContracts = ref<any[]>([])

  // Reusable fetch function
  const fetchContracts = async (type: "provider" | "consumer", contractsRef: Ref) => {
    try {
      const { data } = await subscribedAgreementsServices.getAgreements({
        type,
        offset: 0,
        limit: MAX_CONTRACTS_AGREEMENTS
      })
      contractsRef.value = [...data.result.items]
    } catch (error) {
      console.error(`Failed to fetch ${type} contracts:`, error)
      contractsRef.value = []
    }
  }

  // Actions
  const fetchProviderContracts = () => fetchContracts("provider", providerContracts)
  const fetchConsumerContracts = () => fetchContracts("consumer", consumerContracts)

  return {
    providerContracts,
    consumerContracts,
    fetchProviderContracts,
    fetchConsumerContracts
  }
})

export default useHomeStore
